<template>
  <div class="list-wrapper" style="clear:both">
    <span v-for="culture in currentValue" :key="culture[priceKey]">
      <div style="clear:both">
        <div style="width:30%;float:left">
          <label style="display:inline;">{{ culture.description }}</label>
        </div>
        <div style="width:70%;float:right">
          <div style="width:45%;float:left">
            <MDinput
              v-model="culture.price"
              type="currency"
              :value="culture.price"
              :precision="2"
              currency-prefix=""
              clearable
            />
          </div>
          <div style="width:50%;float:right">
            <el-select v-model="culture.currencyID" class="search-select" type="select">
              <el-option-group v-if="currencies.length" :label="$t('priceListItemPrice.currency')">
                <el-option
                  v-for="currency in currencies"
                  :key="currency.id"
                  :label="currency.description + ' (' + currency.symbol + ')'"
                  :value="currency.id"
                />
              </el-option-group>
            </el-select>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import MDinput from '@/components/MDinput';

export default {
  components: { MDinput },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    priceKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentValue: this.value
    };
  },
  computed: {
    currencies() {
      return this.$store.getters['currency/loadedItems'];
    }
  },
  watch: {
    value(value) {
      this.currentValue = value;
    }
  },
  methods: {
    inputChange() {
      this.$emit('input', this.value);
      this.$emit('change', this.value);
    }
  }
};
</script>
